import React from "react";
import styled from "styled-components";
import { SplitButton } from "../../lib";
import { SplitButtonProps } from "../../lib/form/SplitButton";

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 50px 0;
`;

export default function Mode({ selected, values, onChange }: SplitButtonProps) {
    return (
        <Container>
            <SplitButton
                selected={selected}
                values={values}
                onChange={onChange}
            />
        </Container>
    );
}
